import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import './product.css';
import './layout.css';
import './cockpit.css';

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
